import { MultiViewLeagueInfo } from "../../models/MultiViewLeagueInfo";
import { LeagueInfoLegacy } from "../../../../../interfaces";

export class MultiViewLeagueInfoParser {

    public static Parse(leagueData: LeagueInfoLegacy): MultiViewLeagueInfo {

        return new MultiViewLeagueInfo({
            id : leagueData.ID.toString(),
            name : leagueData.Name,
            sortId : leagueData.SortID,
            rankId : leagueData.RankID,
            countryName : leagueData.CountryName,
            masterLeagueId : leagueData.MasterLeagueID.toString(),
            urlCode : leagueData.UrlCode,
            eventIds : []
        });
    }
}